import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_CAMPAIGN_SUMMARY',
    'FETCH_CAMPAIGN_SUMMARY_SUCCESS',
    'FETCH_CONVERSION_SUMMARY',
    'FETCH_CONVERSION_SUMMARY_SUCCESS',
    'FETCH_KEYWORD_SUMMARY',
    'FETCH_KEYWORD_SUMMARY_SUCCESS',
    'FETCH_ADGROUP_SUMMARY',
    'FETCH_ADGROUP_SUMMARY_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'SEM');


// Action Creators
export const fetchSemCampaignSummary = createAction(actions.FETCH_CAMPAIGN_SUMMARY, params => params);
export const semCampaignSummaryFetched = createAction(actions.FETCH_CAMPAIGN_SUMMARY_SUCCESS, data => data);
export const fetchSemConversionSummary = createAction(actions.FETCH_CONVERSION_SUMMARY, params => params);
export const semConversionSummaryFetched = createAction(actions.FETCH_CONVERSION_SUMMARY_SUCCESS, data => data);
export const fetchSemKeywordSummary = createAction(actions.FETCH_KEYWORD_SUMMARY, params => params);
export const semKeywordSummaryFetched = createAction(actions.FETCH_KEYWORD_SUMMARY_SUCCESS, data => data);
export const fetchSemAdgroupSummary = createAction(actions.FETCH_ADGROUP_SUMMARY, params => params);
export const semAdgroupSummaryFetched = createAction(actions.FETCH_ADGROUP_SUMMARY_SUCCESS, data => data);
export const resetSEMInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialSummaryState = {
    data: undefined,
    hasData: null
};

const initialState = {
    campaign: {
        summary: initialSummaryState
    },
    conversion: {
        summary: initialSummaryState
    },
    keyword: {
        summary: initialSummaryState
    },
    adgroup: {
        summary: initialSummaryState
    }
};

export default handleActions({

    [actions.FETCH_KEYWORD_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                keyword: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            keyword: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ADGROUP_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                adgroup: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            adgroup: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_CAMPAIGN_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                campaign: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            campaign: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_CONVERSION_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                conversion: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            conversion: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/sem/duck.js